import React, {useEffect} from "react";
import Cookies from 'universal-cookie';
import axios from "axios";
import {logoutURL} from "../constants";
const cookies = new Cookies;

export const ForceLogin =()=>{
    useEffect(()=>{
        localStorage.clear();
        cookies.set('token','',{domain:".rainscales.com.vn"});
        cookies.set('refresh','',{domain:".rainscales.com.vn"});
        // Xóa toàn bộ cookies có thể do khởi tạo nhiều
        document.cookie.split(";").forEach((c) => {
          document.cookie = c
            .replace(/^ +/, "")
            .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });
        axios.get(logoutURL).then(res=>{
            window.location.reload();
        });
    });
    return ('');
};

